// extracted by mini-css-extract-plugin
module.exports = {"errors":"ParameterInputExpanded_errors_3HLzx","hint":"ParameterInputExpanded_hint_LEUNi"};